module.exports = __webpack_public_path__ + "static/media/material_master_pro.acd41bf7.csv";